/**
 * Per-player model assignments.
 *
 * Key: lowercased player name (what each friend types as their name on join).
 * url: path relative to client/public, served at the same path at runtime.
 *      Example: file at client/public/models/conor.glb -> url "/models/conor.glb"
 *
 * Edit this map as friends finish their models. Players not listed here get the
 * procedural "boxman" fallback colored from their player id.
 *
 * Animation clip names the loader looks for inside the .glb (case-insensitive):
 *   idle, run, jump, fire     (override with animationMap if your clips have other names)
 *
 * See CHARACTERS.md for the full modeling/rigging/export workflow.
 */
export type ModelEntry = {
  url: string;
  scale?: number;
  yawOffset?: number;
  yOffset?: number;
  color?: number;
  animationMap?: Partial<Record<"idle" | "run" | "jump" | "fire", string>>;
};

export const MODEL_REGISTRY: Record<string, ModelEntry> = {
  // example:
  // "conor": { url: "/models/conor.glb" },
  // "alex":  { url: "/models/alex.glb", scale: 0.95, yawOffset: Math.PI },
};

export function lookupModel(name: string | undefined): ModelEntry | undefined {
  if (!name) return undefined;
  return MODEL_REGISTRY[name.toLowerCase().trim()];
}
